import { Strong } from '@radix-ui/themes'
import { type Fetcher, type Navigation } from '@remix-run/react'
import { type TFunction } from 'i18next'
import * as React from 'react'

import { StringToComponent } from '#app/components/common/string-to-component.tsx'
import { type GetTaxon } from '#app/models/ecommerce-providers/sylius/shop/fetch/taxon/get-taxon.ts'
import { type App } from '#app/routes/_layout/route-config.ts'
import { useNotify } from '#app/utils/hooks/use-notify.ts'

/* -------------------------------------------------------------------------------------------------
 * useProductsTaxonNotify
 * -----------------------------------------------------------------------------------------------*/

type UseProductsTaxonNotifyProps = {
	setApp: React.Dispatch<React.SetStateAction<App>>
	fetcher: Fetcher
	t: TFunction<string, undefined>
	optimisticTaxon: GetTaxon
	navigation: Navigation
}

const useProductsTaxonNotify = ({
	setApp,
	fetcher,
	t,
	optimisticTaxon,
	navigation,
}: UseProductsTaxonNotifyProps) =>
	useNotify({
		...fetcher,
		// same: optimisticTaxon !== currentTaxon,
		search: navigation.location?.search,
		setApp,
		translations: {
			success: {
				title: t('notify.setProductTaxon.success.title'),
				description: (
					<StringToComponent
						text={t('notify.setProductTaxon.success.description-$val')}
					>
						<Strong>{optimisticTaxon?.name}</Strong>
					</StringToComponent>
				),
			},
			error: {
				title: t('notify.setProductTaxon.error.title'),
				description: (
					<StringToComponent
						text={t('notify.setProductTaxon.error.description-$val')}
					>
						<Strong>{optimisticTaxon?.name}</Strong>
					</StringToComponent>
				),
			},
		},
	})

/* -----------------------------------------------------------------------------------------------*/

export { type UseProductsTaxonNotifyProps, useProductsTaxonNotify }
